import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CrudBaseService } from '../crud.service';
import { DocumentModels } from '../models';
import { Observable, of } from 'rxjs';
import { switchMap, map } from 'rxjs/operators';
import { isEmpty } from 'lodash';
import { TenantName } from '@shared/models/tenant-name';

@Injectable()
export class DocumentPerTenantService extends CrudBaseService<DocumentModels.LegalDocument> {
    private filterTenant: TenantName;
    private placeHolderEndpoint: string;
    constructor(httpClient: HttpClient) {
        super('/document/tenant/{0}', httpClient);
        this.placeHolderEndpoint = this.baseUrl;
    }

    filterByTenant(
        tenant: TenantName,
        filterParams: any
    ): Observable<DocumentModels.LegalDocument[]> {
        this.updateBaseUrlByTenant(tenant, 'legal');
        return this.filter(filterParams);
    }

    createDocumentThenUpload(
        tenant: TenantName,
        body: DocumentModels.LegalDocument,
        fileBinary: any
    ): Observable<DocumentModels.AmazonS3DocumentBase> {
        this.updateBaseUrlByTenant(tenant);
        return this.create(body).pipe(
            map((res: any) => res.data),
            switchMap((result: DocumentModels.AmazonS3DocumentBase) => {
                return this.httpClient
                    .put(result.s3_object_id, fileBinary, {
                        headers: {
                            'is-external': 'true',
                            'Content-Type': 'application/octet-stream',
                        },
                    })
                    .pipe(switchMap(() => of(result)));
            })
        );
    }

    private updateBaseUrlByTenant(tenant: TenantName, postfix = '') {
        this.baseUrl = this.placeHolderEndpoint.replace(/\{0\}/, tenant);
        if (!isEmpty(postfix)) {
            this.baseUrl += '/' + postfix;
        }
    }
}
